module.exports = __webpack_public_path__ + "media/images/entreprise-footer-2-4d87601ff41fde48934d34c9d10d904b.png";